import { render, staticRenderFns } from "./SyndicationWidget.vue?vue&type=template&id=1a1ae43a&"
import script from "./SyndicationWidget.vue?vue&type=script&lang=js&"
export * from "./SyndicationWidget.vue?vue&type=script&lang=js&"
import style0 from "./SyndicationWidget.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports